import "./index.css"

import { jsxs, jsx } from 'react/jsx-runtime';
import { Card } from '@design-system/card';
import classNames from 'classnames';

const BASE_CLASS = 'cds-page-card';
const PageCard = ({ className, link, variant, cardContent, cardCta, cardMedia, cardLabel, categories, }) => {
    const { headingBlock, disclaimer, category } = cardContent;
    const headingBlockWithLink = Object.assign(Object.assign({}, headingBlock), { headlineLink: link });
    const categoryClasses = (categories === null || categories === void 0 ? void 0 : categories.map((title) => `${BASE_CLASS}--${title}`)) || [];
    return (jsxs(Card, Object.assign({ className: classNames(BASE_CLASS, ...categoryClasses, className), hasMedia: !!cardMedia, variant: variant }, { children: [jsx(Card.CardContent, Object.assign({ headingBlock: headingBlockWithLink, disclaimer: disclaimer, category: category }, { children: cardCta && jsx(Card.CardCTA, Object.assign({}, cardCta)) })), cardMedia || cardLabel ? (jsx(Card.CardMedia, Object.assign({}, (variant === 'standard' ? { mediaVariant: 'rounded' } : {}), cardMedia, { children: cardLabel && jsx(Card.CardLabel, Object.assign({}, cardLabel)) }))) : null] })));
};

export { PageCard };
